import { messageApi } from './axios';

// API для работы с сообщениями
export const getMessages = async (params = {}) => {
  const response = await messageApi.get('/messages', { 
    params: {
      ...params,
      direction: params.direction || 'incoming'  // По умолчанию входящие, но можно переопределить
    }
  });
  return response.data;
};

// Универсальный метод для получения сообщений с фильтрацией по направлению
export const getAllMessages = async (params = {}) => {
  // Используем новый универсальный эндпоинт с параметром direction
  const response = await messageApi.get('/messages', { 
    params: {
      ...params,
      direction: 'all'  // Получаем все сообщения
    }
  });
  
  return response.data;
};

export const getMessage = async (messageUid) => {
  const response = await messageApi.get(`/messages/${messageUid}`);
  return response.data;
};

export const createMessage = async (messageData) => {
  const response = await messageApi.post('/messages', messageData);
  return response.data;
};

export const updateMessage = async (messageUid, messageData) => {
  const response = await messageApi.put(`/messages/${messageUid}`, messageData);
  return response.data;
};

export const deleteMessage = async (messageUid) => {
  const response = await messageApi.delete(`/messages/${messageUid}`);
  return response.data;
};

export const markAsRead = async (messageUid) => {
  const response = await messageApi.post(`/messages/${messageUid}/read`);
  return response.data;
};

export const bulkMarkAsRead = async (messageUids) => {
  const response = await messageApi.post('/messages/bulk/read', {
    message_uids: messageUids
  });
  return response.data;
};

export const getSentMessages = async (params = {}) => {
  const response = await messageApi.get('/messages', { 
    params: {
      ...params,
      direction: 'outgoing'  // Только исходящие сообщения
    }
  });
  return response.data;
};

export const getDraftMessages = async (params = {}) => {
  const response = await messageApi.get('/messages', { 
    params: {
      ...params,
      direction: 'drafts'  // Только черновики
    }
  });
  return response.data;
};

export const getMessageStats = async () => {
  const response = await messageApi.get('/messages/stats');
  return response.data;
};

export const getGroupDeliveryOptions = async () => {
  const response = await messageApi.get('/messages/delivery-options');
  return response.data;
};

export const sendMessage = async (messageUid) => {
  const response = await messageApi.post(`/messages/${messageUid}/send`);
  return response.data;
};

// API для работы с тредами
export const getThreadMessages = async (messageUid) => {
  const response = await messageApi.get(`/messages/${messageUid}/thread`);
  return response.data;
};

export const getThreadInfo = async (threadUid) => {
  const response = await messageApi.get(`/threads/${threadUid}`);
  return response.data;
};

// API для работы с уведомлениями
export const getNotificationSettings = async () => {
  const response = await messageApi.get('/notifications/settings');
  return response.data;
};

export const updateNotificationSettings = async (settings) => {
  const response = await messageApi.put('/notifications/settings', settings);
  return response.data;
};

export const sendTestEmailNotification = async () => {
  const response = await messageApi.post('/notifications/test/email');
  return response.data;
};

export const sendTestPushNotification = async () => {
  const response = await messageApi.post('/notifications/test/push');
  return response.data;
};

export const getMyNotifications = async (params = {}, signal = null) => {
  const config = { params };
  if (signal) config.signal = signal;
  const response = await messageApi.get('/notifications/my-notifications', config);
  return response.data;
};

export const getNotificationStatus = async (notificationUid) => {
  const response = await messageApi.get(`/notifications/status/${notificationUid}`);
  return response.data;
};

/** Один in-flight GET на время запроса: контекст шапки и страница уведомлений часто дергают stats одновременно. */
let notificationStatsInflight = null;

export const getNotificationStats = async () => {
  if (!notificationStatsInflight) {
    notificationStatsInflight = messageApi
      .get('/notifications/stats')
      .then((response) => response.data)
      .finally(() => {
        notificationStatsInflight = null;
      });
  }
  return notificationStatsInflight;
};

export const getNotificationWebSocketTicket = async () => {
  const response = await messageApi.post('/notifications/websocket/ticket');
  return response.data;
};

// Новые API методы для управления уведомлениями

// Отметка как прочитанное
export const markNotificationAsRead = async (notificationUid) => {
  const response = await messageApi.post(`/notifications/${notificationUid}/read`);
  return response.data;
};

export const markMultipleNotificationsAsRead = async (notificationUids) => {
  const response = await messageApi.post('/notifications/read-multiple', notificationUids);
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await messageApi.post('/notifications/read-all');
  return response.data;
};

// Удаление уведомлений
export const deleteNotification = async (notificationUid) => {
  const response = await messageApi.delete(`/notifications/${notificationUid}`);
  return response.data;
};

export const deleteMultipleNotifications = async (notificationUids) => {
  const response = await messageApi.post('/notifications/delete-multiple', notificationUids);
  return response.data;
};

export const deleteAllReadNotifications = async () => {
  const response = await messageApi.post('/notifications/delete-all-read');
  return response.data;
};

export const deleteAllNotifications = async () => {
  const response = await messageApi.post('/notifications/delete-all');
  return response.data;
};


// --- Admin API уведомлений -------------------------------------------------

export const checkEmailHealth = async () => {
  const response = await messageApi.post('/notifications/email/health');
  return response.data;
};

export const getNotificationQueue = async (params = {}) => {
  const response = await messageApi.get('/notifications/admin/queue', { params });
  return response.data;
};

export const retryNotification = async (notificationUid) => {
  const response = await messageApi.post(`/notifications/admin/retry/${notificationUid}`);
  return response.data;
};

export const getNotificationTemplatesAdmin = async () => {
  const response = await messageApi.get('/notifications/admin/templates');
  return response.data;
};

export const getNotificationTemplateKinds = async () => {
  const response = await messageApi.get('/notifications/admin/templates/kinds');
  return response.data;
};

export const createNotificationTemplate = async (template) => {
  const response = await messageApi.post('/notifications/admin/templates', template);
  return response.data;
};

export const updateNotificationTemplate = async (code, patch) => {
  const response = await messageApi.put(`/notifications/admin/templates/${code}`, patch);
  return response.data;
};

export const resetNotificationTemplate = async (code) => {
  const response = await messageApi.post(`/notifications/admin/templates/${code}/reset`);
  return response.data;
};

export const deleteNotificationTemplate = async (code) => {
  const response = await messageApi.delete(`/notifications/admin/templates/${code}`);
  return response.data;
};


// Константы для фронтенда
export const MESSAGE_CATEGORIES = {
  MESSAGES: 'messages',
  REPAIRS: 'repairs',
  INTERNAL_ORDERS: 'internal_orders',
  CUSTOMER_ORDERS: 'customer_orders',
  COMINGS: 'comings',
  SALES: 'sales',
  DEPOT_RETURNS: 'depot_returns',
  REPORTS: 'reports',
  SYSTEM: 'system'
};

export const MESSAGE_PRIORITIES = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent'
};

export const MESSAGE_STATUSES = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  SENT: 'sent',
  CANCELLED: 'cancelled'
};

export const DELIVERY_TYPES = {
  INDIVIDUAL: 'individual',
  ALL_SERVICE_CENTERS: 'all_service_centers',
  ALL_CUSTOMERS: 'all_customers',
  SERVICE_CENTERS_LIST: 'service_centers_list',
  CUSTOMERS_LIST: 'customers_list',
  SINGLE_SERVICE_CENTER: 'single_service_center',
  SINGLE_CUSTOMER: 'single_customer',
  HIERARCHY_SUBORDINATE: 'hierarchy_subordinate',
  HIERARCHY_SUBORDINATE_SERVICE_CENTERS: 'hierarchy_subordinate_service_centers',
  HIERARCHY_ALL_SUBORDINATE_SERVICE_CENTERS: 'hierarchy_all_subordinate_service_centers',
  HIERARCHY_ALL_SUBORDINATE_CUSTOMERS: 'hierarchy_all_subordinate_customers',
  HIERARCHY_PARENT_SERVICE_CENTER: 'hierarchy_parent_service_center',
  HIERARCHY_PARENT_COMPANY: 'hierarchy_parent_company'
};

export const READ_STATUSES = {
  UNREAD: 'unread',
  READ: 'read'
};

export const DELIVERY_STATUSES = {
  PENDING: 'pending',
  SENT: 'sent',
  DELIVERED: 'delivered',
  FAILED: 'failed'
};

export const NOTIFICATION_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SENT: 'sent',
  DELIVERED: 'delivered',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};

export const NOTIFICATION_READ_STATUSES = {
  UNREAD: 'unread',
  READ: 'read'
};

export default {
  // Сообщения
  getMessages,
  getAllMessages,
  getMessage,
  createMessage,
  updateMessage,
  deleteMessage,
  markAsRead,
  bulkMarkAsRead,
  getSentMessages,
  getDraftMessages,
  getMessageStats,
  getGroupDeliveryOptions,
  sendMessage,
  
  // Треды
  getThreadMessages,
  getThreadInfo,
  
  // Уведомления
  getNotificationSettings,
  updateNotificationSettings,
  sendTestEmailNotification,
  sendTestPushNotification,
  getMyNotifications,
  getNotificationStatus,
  getNotificationStats,
  getNotificationWebSocketTicket,
  
  // Управление уведомлениями
  markNotificationAsRead,
  markMultipleNotificationsAsRead,
  markAllNotificationsAsRead,
  deleteNotification,
  deleteMultipleNotifications,
  deleteAllReadNotifications,
  deleteAllNotifications,

  // Admin
  checkEmailHealth,
  getNotificationQueue,
  retryNotification,
  getNotificationTemplatesAdmin,
  getNotificationTemplateKinds,
  createNotificationTemplate,
  updateNotificationTemplate,
  resetNotificationTemplate,
  deleteNotificationTemplate,
  
  // Константы
  MESSAGE_CATEGORIES,
  MESSAGE_PRIORITIES,
  MESSAGE_STATUSES,
  DELIVERY_TYPES,
  READ_STATUSES,
  DELIVERY_STATUSES,
  NOTIFICATION_STATUSES,
  NOTIFICATION_READ_STATUSES
}; 